import { render, staticRenderFns } from "./checkbox-list.vue?vue&type=template&id=00c9824e&"
import script from "./checkbox-list.ts?vue&type=script&lang=js&"
export * from "./checkbox-list.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports